import ExcelDownload from './ExcelDownload';
export default ExcelDownload;